module.exports = __webpack_public_path__ + "dfece37c60ef634552c1f8db37f9d0c5.woff2";